export enum IInputType {
  String = 'String',
  Number = 'Number',
}
